// extracted by mini-css-extract-plugin
export default {"wrapper":"Toolbar_wrapper__aDev6","styled":"Toolbar_styled__Lcoin"};